export const DAILY_CASH_CLOSE_PERMISSION = {
  VIEW: 'AC_DAILY_CASH_CLOSE_VIEW',
  CREATE: 'AC_DAILY_CASH_CLOSE_CREATE',
  EDIT: 'AC_DAILY_CASH_CLOSE_EDIT',
  APPROVE: 'AC_DAILY_CASH_CLOSE_APPROVE',
  VIEW_ALL: 'AC_DAILY_CASH_CLOSE_VIEW_ALL',
  EXPORT: 'AC_DAILY_CASH_CLOSE_EXPORT',
};
